/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
import { UseHasCabinSafetyCheckAlertVehicleFragmentDoc } from './useHasCabinSafetyCheck.hook'
import { VehicleMissionCardHeaderFragmentDoc } from './VehicleMissionCardHeader/vehicleMissionCardHeader.hook'
export type VehicleMissionCardVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  isSelfDriving: boolean
  totalChildrenInVehicle: number | null
  totalPassengersInVehicle: number | null
  totalPassengersToPickUp: number | null
  totalWheelchairUsersInVehicle: number | null
  pooling: { __typename?: 'Pooling'; reason: Types.PoolingReason | null } | null
  currentlyLocatedInHub: { __typename?: 'Hub'; id: string } | null
  fccUpcomingWaypoints: Array<{
    __typename?: 'FccWaypoint'
    id: string
    adState: Types.FccWaypointState | null
    adStateUpdatedAt: string | null
    routeProvider: Types.FccRouteProvider | null
    cabinSafetyCheckStatus: Types.FccCabinSafetyCheckStatus | null
    stop: {
      __typename?: 'Stop'
      id: string
      names: Partial<Record<'de' | 'en', string>>
      serviceArea: { __typename?: 'ServiceArea'; id: string }
    } | null
    actions: Array<
      | {
          __typename: 'FccWaypointDeliveryAction'
          id: string
          estimatedAt: string
          deliveryStatus: Types.FccWaypointDeliveryActionStatus
          promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
          customer: {
            __typename?: 'Customer'
            id: string
            firstName: string | null
            lastName: string | null
          } | null
          seats: {
            __typename?: 'FccWaypointSeatInfo'
            seats: number
            childSeats: number
            boosterSeats: number
            wheelchairs: number
          }
        }
      | {
          __typename: 'FccWaypointHubReturnAction'
          id: string
          estimatedAt: string
          reason: Types.FccWaypointHubReturnReason
          promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
          area: {
            __typename?: 'Area'
            id: string
            name: string | null
            type: Types.AreaType
            serviceArea: { __typename?: 'ServiceArea'; id: string }
          } | null
        }
      | {
          __typename: 'FccWaypointPickupAction'
          id: string
          estimatedAt: string
          adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
          notShownUpAt: string | null
          tripIsCancelled: boolean | null
          pickupStatus: Types.FccWaypointPickupActionStatus
          promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
          customer: {
            __typename?: 'Customer'
            id: string
            firstName: string | null
            lastName: string | null
          } | null
          seats: {
            __typename?: 'FccWaypointSeatInfo'
            seats: number
            childSeats: number
            boosterSeats: number
            wheelchairs: number
          }
        }
      | {
          __typename: 'FccWaypointReallocationAction'
          id: string
          estimatedAt: string
          promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
        }
    >
  }> | null
  fccCurrentAdAlerts?: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename?: 'FccAdAlert'
      id: string
      type: Types.FccAdAlertType
      status: Types.FccAdAlertStatus
    }>
  } | null
}

export type VehicleMissionPickupActionFragment = {
  __typename: 'FccWaypointPickupAction'
  id: string
  estimatedAt: string
  adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
  notShownUpAt: string | null
  tripIsCancelled: boolean | null
  pickupStatus: Types.FccWaypointPickupActionStatus
  promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
  customer: {
    __typename?: 'Customer'
    id: string
    firstName: string | null
    lastName: string | null
  } | null
  seats: {
    __typename?: 'FccWaypointSeatInfo'
    seats: number
    childSeats: number
    boosterSeats: number
    wheelchairs: number
  }
}

export type VehicleMissionDeliveryActionFragment = {
  __typename: 'FccWaypointDeliveryAction'
  id: string
  estimatedAt: string
  deliveryStatus: Types.FccWaypointDeliveryActionStatus
  promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
  customer: {
    __typename?: 'Customer'
    id: string
    firstName: string | null
    lastName: string | null
  } | null
  seats: {
    __typename?: 'FccWaypointSeatInfo'
    seats: number
    childSeats: number
    boosterSeats: number
    wheelchairs: number
  }
}

export type VehicleMissionHubReturnActionFragment = {
  __typename: 'FccWaypointHubReturnAction'
  id: string
  estimatedAt: string
  reason: Types.FccWaypointHubReturnReason
  promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
  area: {
    __typename?: 'Area'
    id: string
    name: string | null
    type: Types.AreaType
    serviceArea: { __typename?: 'ServiceArea'; id: string }
  } | null
}

export type VehicleMissionReallocationActionFragment = {
  __typename: 'FccWaypointReallocationAction'
  id: string
  estimatedAt: string
  promisedTimeRange: { __typename?: 'DateTimeInterval'; to: string }
}

export const VehicleMissionPickupActionFragmentDoc = gql`
    fragment vehicleMissionPickupAction on FccWaypointPickupAction {
  __typename
  id
  promisedTimeRange {
    to
  }
  estimatedAt
  customer {
    id
    firstName
    lastName
  }
  seats {
    seats
    childSeats
    boosterSeats
    wheelchairs
  }
  adPassengerAuthenticationState
  notShownUpAt
  tripIsCancelled
  pickupStatus: status
}
    `
export const VehicleMissionDeliveryActionFragmentDoc = gql`
    fragment vehicleMissionDeliveryAction on FccWaypointDeliveryAction {
  __typename
  id
  promisedTimeRange {
    to
  }
  estimatedAt
  customer {
    id
    firstName
    lastName
  }
  seats {
    seats
    childSeats
    boosterSeats
    wheelchairs
  }
  deliveryStatus: status
}
    `
export const VehicleMissionHubReturnActionFragmentDoc = gql`
    fragment vehicleMissionHubReturnAction on FccWaypointHubReturnAction {
  __typename
  id
  promisedTimeRange {
    to
  }
  estimatedAt
  area {
    id
    serviceArea {
      id
    }
    name
    type
  }
  reason
}
    `
export const VehicleMissionReallocationActionFragmentDoc = gql`
    fragment vehicleMissionReallocationAction on FccWaypointReallocationAction {
  __typename
  id
  promisedTimeRange {
    to
  }
  estimatedAt
}
    `
export const VehicleMissionCardVehicleFragmentDoc = gql`
    fragment VehicleMissionCardVehicle on Vehicle {
  id
  pooling {
    reason
  }
  isSelfDriving
  currentlyLocatedInHub {
    id
  }
  fccUpcomingWaypoints {
    id
    adState
    adStateUpdatedAt
    stop {
      id
      names
      serviceArea {
        id
      }
    }
    actions {
      __typename
      ... on FccWaypointPickupAction {
        ...vehicleMissionPickupAction
      }
      ... on FccWaypointDeliveryAction {
        ...vehicleMissionDeliveryAction
      }
      ... on FccWaypointHubReturnAction {
        ...vehicleMissionHubReturnAction
      }
      ... on FccWaypointReallocationAction {
        ...vehicleMissionReallocationAction
      }
    }
    routeProvider
    cabinSafetyCheckStatus
  }
  ...VehicleMissionCardHeader
  ...UseHasCabinSafetyCheckAlertVehicle
}
    ${VehicleMissionPickupActionFragmentDoc}
${VehicleMissionDeliveryActionFragmentDoc}
${VehicleMissionHubReturnActionFragmentDoc}
${VehicleMissionReallocationActionFragmentDoc}
${VehicleMissionCardHeaderFragmentDoc}
${UseHasCabinSafetyCheckAlertVehicleFragmentDoc}`
